module.exports = __webpack_public_path__ + "static/media/cap.e371ed3d.svg";